import Storage from "./Storage";
import { getDashboardUrl } from "./Urls";
// NOTE:- here name are always titilecases
export const proProfileDetails = [
    {
        name: "Driver",
        profileId: 6,
        title: "Driver",
        subscription_id: 5,
        organization_type:"Mover"
    },
    {
        name: "Helper",
        profileId: 5,
        title: "Helper",
        subscription_id: 7,
        organization_type:""
    },
    {
        name: "Packer",
        profileId: 12,
        title: "Packer",
        subscription_id: 9,
        organization_type:"Mover"
    },
    {
        name: "Thirdparty",
        profileId: 13,
        title: "3rd Party",
        subscription_id: 11,
        organization_type:"3rd Party"
    },
    {
        name: "Claimrepair",
        profileId: 14,
        title: "Claim Repair",
        subscription_id: 13,
        organization_type:"Claim Repair"
    }
];

export const getProfileConfig = (path = null) => {
    const url = path ? path : window.location.href;
    return proProfileDetails.find(profile => url.lastIndexOf(profile.name.toLowerCase()) !== -1);

}
export const setAuthDataInCookie = (result) => {
    const profileConfig = proProfileDetails.find(profile => profile.profileId == result.data.profile_id);
    if (profileConfig) {
        Storage.set(`myReloPro${profileConfig.name}LoginToken`, result.token);
        Storage.set(`myReloPro${profileConfig.name}LoginData`, JSON.stringify(result.data, ["id", "user_id", "profile_id", "first_name", "last_name", "email"]));
        //redirect to dashbord page
        window.location.href = getDashboardUrl(profileConfig.name);
    }
}
